import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {flexAbsoluteCenter, flexJustifyCenter, mb, mt} from "@pg-design/helpers-css";
import {BrandSearchIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {LISTING_VENDOR_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {ColumnList} from "../../../atoms/ColumnList";
import {ColumnListItem} from "../../../atoms/ColumnListItem";
import {DesktopBlend} from "../../../atoms/DesktopBlend";
import {InfoPanel} from "../../../atoms/InfoPanel";
import {calculatePriceFromInstalment} from "../../../credit_calculator/utils/calculate_price_from_instalment";
import {IOfferBox, OfferBox} from "../../../offer/components/offer_box/OfferBox";
import {showOfferModal} from "../../../offer/state/offer_modals_slice";
import {hitGTMOfferViewItemList} from "../../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_view_item_list";
import {offerBoxTracking} from "../../../offer/tracking/offer_box_gtm_events";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {OfferType} from "../../../offer/types/OfferType";
import {getOfferCardAddress, IOfferCardAddressContext} from "../../../offer/utils/get_offer_card_address";
import {Country} from "../../../region/types/Country";
import {useUserPreferencesFilters} from "../../../user/hooks/use_user_preferences_filters";
import {InvestmentOfferEbookSectionSpain} from "../../components/InvestmentOfferEbookSectionSpain";
import {InvestmentOfferListModal} from "../../components/InvestmentOfferListModal";
import {IInvestmentOffersOffersStore} from "../reducers/investment_offer_list_reducer";

interface IProps extends Pick<IInvestmentOffersOffersStore, "offerList" | "latestQuery"> {
    addressContext: IOfferCardAddressContext;
    isLoading: boolean;
}

const modalName: IOfferModalName = "mainOfferModal";

export const InvestmentOfferListListSection = (props: IProps) => {
    const dispatch = useDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const instalment = searchFormValues.instalment;
    const middleIndex = Math.floor(props.offerList.length / 2);
    const trackingMeta: IOfferBox["trackingMeta"] = {
        listName: "Oferty pod inwestycje",
        listId: "oferty_pod_inwestycje",
        source: "additional",
        tileEvents: {
            imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
            buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
            linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
            logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
        }
    };

    useEffect(() => {
        if (props.offerList.length) {
            hitGTMOfferViewItemList({
                offers: props.offerList,
                ...trackingMeta
            });
        }
    }, [props.offerList]);

    if (!props.offerList.length) {
        return (
            <WideContent css={mt(3)}>
                <InfoPanel
                    icon={BrandSearchIcon}
                    heading="Niestety nic nie znaleźliśmy"
                    headingAs="h1"
                    subHeading="Zmień parametry wyszukania i spróbuj ponownie"
                    subHeadingAs="p"
                />
            </WideContent>
        );
    }

    return (
        <>
            <ColumnList css={mb(8)}>
                {props.isLoading && (
                    <DesktopBlend top="12rem" isActive>
                        <div css={[flexJustifyCenter, mt(12)]}>
                            <Loader size="lg" />
                        </div>
                    </DesktopBlend>
                )}

                {props.offerList.map((offer, idx: number) => {
                    const position = idx + 1;
                    return (
                        <>
                            <ColumnListItem data-testid={LISTING_VENDOR_TEST_IDS.FIRST_LISTING_ELEMENT} key={offer.id}>
                                <OfferBox
                                    offer={offer}
                                    displayAddress={getOfferCardAddress(offer, props.addressContext)}
                                    index={idx}
                                    dataTestId={LISTING_VENDOR_TEST_IDS.PROPERTY_CONTAINER}
                                    onShowOfferDetailsBtnClick={() => {
                                        dispatch(
                                            showOfferModal({
                                                modalName,
                                                offerId: offer.id,
                                                offer,
                                                filters: {
                                                    rooms: {
                                                        lower: userPreferencesFilters.rooms_0 ? +userPreferencesFilters.rooms_0 : "",
                                                        upper: userPreferencesFilters.rooms_1 ? +userPreferencesFilters.rooms_1 : ""
                                                    },
                                                    area: {
                                                        lower: userPreferencesFilters.area_0 ? userPreferencesFilters.area_0 : "",
                                                        upper: userPreferencesFilters.area_1 ? userPreferencesFilters.area_1 : ""
                                                    },
                                                    floor_choices: userPreferencesFilters.floor_choices?.map(Number) || [],
                                                    price: {
                                                        lower: instalment ? "" : searchFormValues.price.lower || "",
                                                        upper: instalment ? calculatePriceFromInstalment(instalment) : searchFormValues.price.upper || ""
                                                    }
                                                }
                                            })
                                        );
                                    }}
                                    offerDetailsBtnText={offer.type === OfferType.FLAT ? "Zobacz apartamenty" : "Zobacz domy"}
                                    trackingMeta={trackingMeta}
                                />
                            </ColumnListItem>
                            {offer.region.country === Country.SPAIN && position === middleIndex && (
                                <WideContent css={wideContentStyle}>
                                    <InvestmentOfferEbookSectionSpain />
                                </WideContent>
                            )}
                        </>
                    );
                })}
            </ColumnList>
            <InvestmentOfferListModal />
        </>
    );
};

const wideContentStyle = css`
    ${flexAbsoluteCenter};
    width: 100%;
`;
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {flexAbsoluteCenter, flexJustifyCenter, mb, mt} from "@pg-design/helpers-css";
import {BrandSearchIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {LISTING_VENDOR_TEST_IDS} from "@pg-mono/test-ids";

import {IRPStore} from "../../../app/rp_reducer";
import {ColumnList} from "../../../atoms/ColumnList";
import {ColumnListItem} from "../../../atoms/ColumnListItem";
import {DesktopBlend} from "../../../atoms/DesktopBlend";
import {InfoPanel} from "../../../atoms/InfoPanel";
import {calculatePriceFromInstalment} from "../../../credit_calculator/utils/calculate_price_from_instalment";
import {IOfferBox, OfferBox} from "../../../offer/components/offer_box/OfferBox";
import {showOfferModal} from "../../../offer/state/offer_modals_slice";
import {hitGTMOfferViewItemList} from "../../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_view_item_list";
import {offerBoxTracking} from "../../../offer/tracking/offer_box_gtm_events";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {OfferType} from "../../../offer/types/OfferType";
import {getOfferCardAddress, IOfferCardAddressContext} from "../../../offer/utils/get_offer_card_address";
import {Country} from "../../../region/types/Country";
import {useUserPreferencesFilters} from "../../../user/hooks/use_user_preferences_filters";
import {InvestmentOfferEbookSectionSpain} from "../../components/InvestmentOfferEbookSectionSpain";
import {InvestmentOfferListModal} from "../../components/InvestmentOfferListModal";
import {IInvestmentOffersOffersStore} from "../reducers/investment_offer_list_reducer";

interface IProps extends Pick<IInvestmentOffersOffersStore, "offerList" | "latestQuery"> {
    addressContext: IOfferCardAddressContext;
    isLoading: boolean;
}

const modalName: IOfferModalName = "mainOfferModal";

export const InvestmentOfferListListSection = (props: IProps) => {
    const dispatch = useDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const instalment = searchFormValues.instalment;
    const middleIndex = Math.floor(props.offerList.length / 2);
    const trackingMeta: IOfferBox["trackingMeta"] = {
        listName: "Oferty pod inwestycje",
        listId: "oferty_pod_inwestycje",
        source: "additional",
        tileEvents: {
            imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
            buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
            linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
            logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
        }
    };

    useEffect(() => {
        if (props.offerList.length) {
            hitGTMOfferViewItemList({
                offers: props.offerList,
                ...trackingMeta
            });
        }
    }, [props.offerList]);

    if (!props.offerList.length) {
        return (
            <WideContent css={mt(3)}>
                <InfoPanel
                    icon={BrandSearchIcon}
                    heading="Niestety nic nie znaleźliśmy"
                    headingAs="h1"
                    subHeading="Zmień parametry wyszukania i spróbuj ponownie"
                    subHeadingAs="p"
                />
            </WideContent>
        );
    }

    return (
        <>
            <ColumnList css={mb(8)}>
                {props.isLoading && (
                    <DesktopBlend top="12rem" isActive>
                        <div css={[flexJustifyCenter, mt(12)]}>
                            <Loader size="lg" />
                        </div>
                    </DesktopBlend>
                )}

                {props.offerList.map((offer, idx: number) => {
                    const position = idx + 1;
                    return (
                        <>
                            <ColumnListItem data-testid={LISTING_VENDOR_TEST_IDS.FIRST_LISTING_ELEMENT} key={offer.id}>
                                <OfferBox
                                    offer={offer}
                                    displayAddress={getOfferCardAddress(offer, props.addressContext)}
                                    index={idx}
                                    dataTestId={LISTING_VENDOR_TEST_IDS.PROPERTY_CONTAINER}
                                    onShowOfferDetailsBtnClick={() => {
                                        dispatch(
                                            showOfferModal({
                                                modalName,
                                                offerId: offer.id,
                                                offer,
                                                filters: {
                                                    rooms: {
                                                        lower: userPreferencesFilters.rooms_0 ? +userPreferencesFilters.rooms_0 : "",
                                                        upper: userPreferencesFilters.rooms_1 ? +userPreferencesFilters.rooms_1 : ""
                                                    },
                                                    area: {
                                                        lower: userPreferencesFilters.area_0 ? userPreferencesFilters.area_0 : "",
                                                        upper: userPreferencesFilters.area_1 ? userPreferencesFilters.area_1 : ""
                                                    },
                                                    floor_choices: userPreferencesFilters.floor_choices?.map(Number) || [],
                                                    price: {
                                                        lower: instalment ? "" : searchFormValues.price.lower || "",
                                                        upper: instalment ? calculatePriceFromInstalment(instalment) : searchFormValues.price.upper || ""
                                                    }
                                                }
                                            })
                                        );
                                    }}
                                    offerDetailsBtnText={offer.type === OfferType.FLAT ? "Zobacz apartamenty" : "Zobacz domy"}
                                    trackingMeta={trackingMeta}
                                />
                            </ColumnListItem>
                            {offer.region.country === Country.SPAIN && position === middleIndex && (
                                <WideContent css={wideContentStyle}>
                                    <InvestmentOfferEbookSectionSpain />
                                </WideContent>
                            )}
                        </>
                    );
                })}
            </ColumnList>
            <InvestmentOfferListModal />
        </>
    );
};

const wideContentStyle = css`
    ${flexAbsoluteCenter};
    width: 100%;
`;
